import * as PropTypes from "prop-types";

import { RS } from "../../../data/strings/global";
import * as SC from "../../../data/strings/PIStringConst";

import * as pic from "../NonComponents/PIConst";
import * as pisc from "../NonComponents/PIServerConst";
import * as pias from "./PIAppState";
//import * as piasu from "./PIAppStateUtil";

/*****************************************************************************/
/*    Utility methods that are ModVar-independent should be placed here.     */
/*****************************************************************************/

/* These functions return info about default items for user-entered lists. They are
   here because they do not depend on the ModVars. */

export function getPageIDFromOrder(pageOrder) {
  let pageID;

  switch (pageOrder) {
    case pic.welcomeFormOrder:
      pageID = pic.welcomeForm;
      break;

    case pic.gettingStartedFormOrder:
      pageID = pic.gettingStartedForm;
      break;

    case pic.aggregateFormOrder:
      pageID = pic.aggregateForm;
      break;

    case pic.configFormOrder:
      pageID = pic.configForm;
      break;

    case pic.detailedCostsFormOrder:
      pageID = pic.detailedCostsForm;
      break;

    case pic.costsLiteFormOrder:
      pageID = pic.costsLiteForm;
      break;

    case pic.AGYW_FormOrder:
      pageID = pic.AGYW_Form;
      break;

    case pic.impactFormOrder:
      pageID = pic.impactForm;
      break;

    case pic.targetsFormOrder:
      pageID = pic.targetsForm;
      break;

    case pic.resultsDashboardFormOrder:
      pageID = pic.resultsDashboardForm;
      break;

    case pic.disagTargetsFormOrder:
      pageID = pic.disagTargetsForm;
      break;

    case pic.commoditiesForecastFormOrder:
      pageID = pic.commoditiesForecastForm;
      break;

    default:
      pageID = pic.noPageID;
      break;
  }

  return pageID;
}

export function getDefNumItems(itemTypeByte) {
  let numItems;

  switch (itemTypeByte) {
    case pic.priorPopItems:
      numItems = pic.numDefPriorPops;
      break;

    case pic.contVisitSchedItems:
      numItems = pic.numDefContVisitSchedules;
      break;

    case pic.contCurveItems:
      numItems = pic.numDefContCurves;
      break;

    case pic.scaleUpTrendItems:
      numItems = pic.numDefScaleUpTrends;
      break;

    case pic.methodItems:
      numItems = pic.numMethods;
      break;

    default:
      numItems = 0;
      break;
  }

  return numItems;
}

export function getMaxNumItems(itemTypeByte) {
  let numItems;

  switch (itemTypeByte) {
    case pic.priorPopItems:
      numItems = 15;
      break;

    case pic.contVisitSchedItems:
      numItems = 15;
      break;

    case pic.contCurveItems:
      numItems = 15;
      break;

    case pic.scaleUpTrendItems:
      numItems = 10;
      break;

    case pic.methodItems:
      numItems = 10;
      break;

    default:
      numItems = 0;
      break;
  }

  return numItems;
}

export function getDefItemName(itemTypeByte, mstID) {
  let itemNameStr;

  switch (itemTypeByte) {
    case pic.priorPopItems:
      itemNameStr = getDefPriorPopNameFromMstID(mstID);
      break;

    case pic.contVisitSchedItems:
      itemNameStr = getDefContVisitSchedNameFromMstID(mstID);
      break;

    case pic.contCurveItems:
      itemNameStr = getDefContCurveNameFromMstID(mstID);
      break;

    case pic.scaleUpTrendItems:
      itemNameStr = getDefScaleUpTrendNameFromMstID(mstID);
      break;

    case pic.methodItems:
      itemNameStr = getDefMethodNameFromMstID(mstID);
      break;

    default:
      itemNameStr = "";
      break;
  }

  return itemNameStr;
}

export function getDefItemEnabled(itemTypeByte, mstID) {
  let itemEnabledBool;

  switch (itemTypeByte) {
    case pic.methodItems:
      itemEnabledBool = getDefMethodEnabled(mstID);
      break;

    default:
      itemEnabledBool = true;
      break;
  }

  return itemEnabledBool;
}

// export function getDefItemMstID(itemTypeByte, currID) {
//   let itemMstID;

//   switch (itemTypeByte) {
//     case pic.priorPopItems:
//       itemMstID = getDefPriorPopMstID(currID);
//       break;

//     case pic.contVisitSchedItems:
//       itemMstID = getDefContVisitSchedMstID(currID);
//       break;

//     case pic.contCurveItems:
//       itemMstID = getDefContCurveMstID(currID);
//       break;

//     case pic.scaleUpTrendItems:
//       itemMstID = getDefScaleUpTrendMstID(currID);
//       break;

//     case pic.methodItems:
//       itemMstID = getDefMethodMstID(currID);
//       break;

//     default:
//       itemMstID = "";
//       break;
//   }

//   return itemMstID;
// }

export function getItemModVarTag(itemTypeByte) {
  let mvTagStr = "";
  switch (itemTypeByte) {
    case pic.priorPopItems:
      mvTagStr = pisc.priorPopsMVTag;
      break;

    case pic.contCurveItems:
      mvTagStr = pisc.continuationCurvesMVTag;
      break;

    case pic.scaleUpTrendItems:
      mvTagStr = pisc.scaleUpTrendsMVTag;
      break;

    case pic.methodItems:
      mvTagStr = pisc.methodsMVTag;
      break;

    default:
      break;
  }

  return mvTagStr;
}

export function getItemMstIDField(itemTypeByte) {
  let fieldStr = "";

  switch (itemTypeByte) {
    case pic.priorPopItems:
      fieldStr = pisc.priorPopMstID;
      break;

    case pic.contVisitSchedItems:
      fieldStr = pisc.contVisitSchedMstID;
      break;

    case pic.contCurveItems:
      fieldStr = pisc.contCurveMstID;
      break;

    case pic.scaleUpTrendItems:
      fieldStr = pisc.scaleUpTrendMstID;
      break;

    case pic.methodItems:
      fieldStr = pisc.methodMstID;
      break;

    default:
      break;
  }

  return fieldStr;
}

export function getItemNameField(itemTypeByte) {
  let fieldStr = "";

  switch (itemTypeByte) {
    case pic.priorPopItems:
      fieldStr = pisc.priorPopName;
      break;

    case pic.contVisitSchedItems:
      fieldStr = pisc.contVisitSchedName;
      break;

    case pic.contCurveItems:
      fieldStr = pisc.contCurveName;
      break;

    case pic.scaleUpTrendItems:
      fieldStr = pisc.scaleUpTrendName;
      break;

    case pic.methodItems:
      fieldStr = pisc.methodName;
      break;

    default:
      break;
  }

  return fieldStr;
}

export function getItemMethodMstIDField(itemTypeByte) {
  let fieldStr = "";

  switch (itemTypeByte) {
    case pic.contVisitSchedItems:
      fieldStr = pisc.contVisitSchedMethodMstID;
      break;

    default:
      break;
  }

  return fieldStr;
}

export function getItemObjArrField(itemTypeByte) {
  let fieldStr = "";

  switch (itemTypeByte) {
    case pic.contVisitSchedItems:
      fieldStr = pisc.contVisitSchedObjArr;
      break;

    default:
      break;
  }

  return fieldStr;
}

export function getCustomItemDefMstID(itemTypeByte) {
  let mstIDStr = "";

  switch (itemTypeByte) {
    case pic.priorPopItems:
      mstIDStr = pisc.SDC_PP_MstID;
      break;

    case pic.contVisitSchedItems:
      mstIDStr = pisc.contVisitSched1MstID;
      break;

    case pic.contCurveItems:
      mstIDStr = pisc.SDCsCCMstID;
      break;

    case pic.scaleUpTrendItems:
      mstIDStr = pisc.scaleUpTrendAMstID;
      break;

    case pic.methodItems:
      mstIDStr = pisc.pillMethodMstID;
      break;

    default:
      break;
  }

  return mstIDStr;
}

export function getMonthName(monthByte) {
  let name = "";

  switch (monthByte) {
    case 1:
      name = RS(SC.GB_stJanuary);
      break;

    case 2:
      name = RS(SC.GB_stFebruary);
      break;

    case 3:
      name = RS(SC.GB_stMarch);
      break;

    case 4:
      name = RS(SC.GB_stApril);
      break;

    case 5:
      name = RS(SC.GB_stMay);
      break;

    case 6:
      name = RS(SC.GB_stJune);
      break;

    case 7:
      name = RS(SC.GB_stJuly);
      break;

    case 8:
      name = RS(SC.GB_stAugust);
      break;

    case 9:
      name = RS(SC.GB_stSeptember);
      break;

    case 10:
      name = RS(SC.GB_stOctober);
      break;

    case 11:
      name = RS(SC.GB_stNovember);
      break;

    case 12:
      name = RS(SC.GB_stDecember);
      break;

    default:
      name = "";
  }

  return name;
}

export function getMonthNum(monthName) {
  let num = "";

  switch (monthName) {
    case RS(SC.GB_stJanuary).toUpperCase():
      num = 1;
      break;

    case RS(SC.GB_stFebruary).toUpperCase():
      num = 2;
      break;

    case RS(SC.GB_stMarch).toUpperCase():
      num = 3;
      break;

    case RS(SC.GB_stApril).toUpperCase():
      num = 4;
      break;

    case RS(SC.GB_stMay).toUpperCase():
      num = 5;
      break;

    case RS(SC.GB_stJune).toUpperCase():
      num = 6;
      break;

    case RS(SC.GB_stJuly).toUpperCase():
      num = 7;
      break;

    case RS(SC.GB_stAugust).toUpperCase():
      num = 8;
      break;

    case RS(SC.GB_stSeptember).toUpperCase():
      num = 9;
      break;

    case RS(SC.GB_stOctober).toUpperCase():
      num = 10;
      break;

    case RS(SC.GB_stNovember).toUpperCase():
      num = 11;
      break;

    case RS(SC.GB_stDecember).toUpperCase():
      num = 12;
      break;

    default:
      num = "";
  }

  return num;
}

export function getFullMonthsArray() {
  let months1DStrArray = [];

  for (let m = 1; m <= 12; m++) {
    months1DStrArray.push(getMonthName(m));
  }

  return months1DStrArray;
}

export function getMonthsArray(monthMstIDIntArr) {
  let months1DStrArray = [];

  for (let i = 0; i < monthMstIDIntArr.length; i++) {
    months1DStrArray.push(getMonthName(monthMstIDIntArr[i]));
  }

  return months1DStrArray;
}

/* Gets month index for TComboBox (itemIndex is 0-based). */
export function getMonthIdx(monthInt) {
  return monthInt - 1;
}

/* Gets year index for TComboBox (itemIndex is 0-based). */
export function getProgDataYearIdx(yearInt) {
  return yearInt - pic.firstPossibleProgramStartYear;
}

/* Gets year index for TComboBox (itemIndex is 0-based). */
export function getTargSetYearIdx(yearInt) {
  return yearInt - pic.firstPossibleTargetStartYear;
}

export function getDefProgramStartYearsArray() {
  let possibleYears1DIntArray = [];

  for (let yr = pic.firstPossibleProgramStartYear; yr <= pic.finalPossibleProgramStartYear; yr++) {
    possibleYears1DIntArray.push(yr);
  }

  return possibleYears1DIntArray;
}

export function getDefProgramEndYearsArray() {
  let possibleYears1DIntArray = [];

  for (let yr = pic.firstPossibleProgramEndYear; yr <= pic.finalPossibleProgramEndYear; yr++) {
    possibleYears1DIntArray.push(yr);
  }

  return possibleYears1DIntArray;
}

export function getAppModeName(appModeMstIDStr) {
  switch (appModeMstIDStr) {
    case pisc.noToolSelectedMstID:
      return RS(SC.GB_stChooseMode);

    case pisc.PrEPitStdToolMstID:
      return RS(SC.GB_stPrEPit);

    case pisc.PrEPitEasyStartToolMstID:
      return RS(SC.GB_stPrEPit); // Easy Start is now Standard mode RS(SC.GB_stEasyStart);

    case pisc.aggregateToolMstID:
      return RS(SC.GB_stAggregate);

    default:
      return "";
  }
}

export function getToolModeMstID(currIDInt) {
  let mstIDStr = "";

  switch (currIDInt) {
    case pic.PrEPitStdTool:
      mstIDStr = pisc.PrEPitStdToolMstID;
      break;

    case pic.PrEPitEasyStartTool:
      mstIDStr = pisc.PrEPitEasyStartToolMstID;
      break;

    case pic.aggregateTool:
      mstIDStr = pisc.aggregateToolMstID;
      break;

    default:
      break;
  }

  return mstIDStr;
}

export function getToolModeCurrID(mstIDStr) {
  let currIDInt = pic.noToolSelected;

  switch (mstIDStr) {
    case pisc.PrEPitStdToolMstID:
      currIDInt = pic.PrEPitStdTool;
      break;

    case pisc.PrEPitEasyStartToolMstID:
      currIDInt = pic.PrEPitEasyStartTool;
      break;

    case pic.aggregateTool:
      mstIDStr = pisc.aggregateToolMstID;
      break;

    default:
  }

  return currIDInt;
}

// const keyPops = RS(SC.GB_stKeyPopCC);
const regPartners = RS(SC.GB_stRegularPartners);
const nonRegPartners = RS(SC.GB_stNonRegularPartners);
// const genPop = RS(SC.GB_stGeneralPopulation);

const males = RS(SC.GB_stMales);
const females = RS(SC.GB_stFemales);

const msm = RS(SC.GB_stMSM);
const fsw = RS(SC.GB_stFSW);
const pwid = RS(SC.GB_stIDU);

// PSE Populations
export const pseBasePops = {
  POP_FSW_F35_39: `${females} 35 - 39: ${fsw}`,
  POP_NREG_M45_49: `${males} 45 - 49: ${nonRegPartners}`,
  POP_NREG_F25_29: `${females} 25 - 29: ${nonRegPartners}`,
  POP_NREG_F45_49: `${females} 45 - 49: ${nonRegPartners}`,
  POP_REG_M25_29: `${males} 25 - 29: ${regPartners}`,
  POP_FSW_F15_19: `${females} 15 - 19: ${fsw}`,
  POP_MSM_M20_24: `${males} 20 - 24: ${msm}`,
  POP_PWID_M25_29: `${males} 25 - 29: ${pwid}`,
  POP_NREG_F20_24: `${females} 20 - 24: ${nonRegPartners}`,
  POP_REG_F15_19: `${females} 15 - 19: ${regPartners}`,
  POP_REG_F25_29: `${females} 25 - 29: ${regPartners}`,
  POP_MSM_M40_44: `${males} 40 - 44: ${msm}`,
  POP_MSM_M30_34: `${males} 30 - 34: ${msm}`,
  POP_REG_M20_24: `${males} 20 - 24: ${regPartners}`,
  POP_NREG_M35_39: `${males} 35 - 39: ${nonRegPartners}`,
  POP_NREG_M15_19: `${males} 15 - 19: ${nonRegPartners}`,
  POP_NREG_M25_29: `${males} 25 - 29: ${nonRegPartners}`,
  POP_REG_F40_44: `${females} 40 - 44: ${regPartners}`,
  POP_NREG_F35_39: `${females} 35 - 39: ${nonRegPartners}`,
  POP_NREG_M40_44: `${males} 40 - 44: ${nonRegPartners}`,
  POP_PWID_M15_19: `${males} 15 - 19: ${pwid}`,
  POP_REG_F30_34: `${females} 30 - 34: ${regPartners}`,
  POP_PWID_M20_24: `${males} 20 - 24: ${pwid}`,
  POP_NREG_F15_19: `${females} 15 - 19: ${nonRegPartners}`,
  POP_MSM_M25_29: `${males} 25 - 29: ${msm}`,
  POP_FSW_F20_24: `${females} 20 - 24: ${fsw}`,
  POP_MSM_M45_49: `${males} 45 - 49: ${msm}`,
  POP_FSW_F25_29: `${females} 25 - 29: ${fsw}`,
  POP_REG_M15_19: `${males} 15 - 19: ${regPartners}`,
  POP_REG_F20_24: `${females} 20 - 24: ${regPartners}`,
  POP_REG_M45_49: `${males} 45 - 49: ${regPartners}`,
  POP_NREG_F40_44: `${females} 40 - 44: ${nonRegPartners}`,
  POP_FSW_F30_34: `${females} 30 - 34: ${fsw}`,
  POP_FSW_F40_44: `${females} 40 - 44: ${fsw}`,
  POP_PWID_M35_39: `${males} 35 - 39: ${pwid}`,
  POP_MSM_M35_39: `${males} 35 - 39: ${msm}`,
  POP_REG_F45_49: `${females} 45 - 49: ${regPartners}`,
  POP_NREG_F30_34: `${females} 30 - 34: ${nonRegPartners}`,
  POP_REG_F35_39: `${females} 35 - 39: ${regPartners}`,
  POP_REG_M35_39: `${males} 35 - 39: ${regPartners}`,
  POP_REG_M30_34: `${males} 30 - 34: ${regPartners}`,
  POP_REG_M40_44: `${males} 40 - 44: ${regPartners}`,
  POP_NREG_M30_34: `${males} 30 - 34: ${nonRegPartners}`,
  POP_FSW_F45_49: `${females} 45 - 49: ${fsw}`,
  POP_PWID_M30_34: `${males} 30 - 34: ${pwid}`,
  POP_PWID_M40_44: `${males} 40 - 44: ${pwid}`,
  POP_MSM_M15_19: `${males} 15 - 19: ${msm}`,
  POP_NREG_M20_24: `${males} 20 - 24: ${nonRegPartners}`,
  POP_PWID_M45_49: `${males} 45 - 49: ${pwid}`,
};

// PSE Incidence Categories
export const pseIncidenceCategories = {
  // low: RS(SC.GB_stLowIncidence),
  moderate: RS(SC.GB_stMediumIncidence),
  high: RS(SC.GB_stHighIncidence),
  // "very high": RS(SC.GB_stVeryHighIncidence),
};

const basePopsWithCategories = Object.fromEntries(
  Object.entries(pseBasePops).flatMap(([k, v]) =>
    Object.keys(pseIncidenceCategories).map((cat) => [
      `${k}_${cat.toUpperCase()}`,
      `${v} (${pseIncidenceCategories[cat]})`,
    ])
  )
);

// Add names for categories

/* Priority populations */
const popNameIDMap = {
  [pisc.SDC_PP_MstID]: RS(SC.GB_stSDC),
  [pisc.AGYW_PP_MstID]: RS(SC.GB_stAGYW15t24),
  [pisc.MSM_PP_MstID]: RS(SC.GB_stMSM),
  [pisc.FSW_PP_MstID]: RS(SC.GB_stFSW),
  [pisc.PWID_PP_MstID]: RS(SC.GB_stIDU),
  [pisc.PBW_PP_MstID]: RS(SC.GB_stPBW),
  [pisc.TP_PP_MstID]: RS(SC.GB_stTP),
  [pisc.customItemMstID]: `${RS(SC.GB_stCustomPriorPop)} 1`,

  // PSE Populations
  ...pseBasePops,
  ...basePopsWithCategories,
};

export function getDefPriorPopNameFromMstID(mstIDStr) {
  return popNameIDMap[mstIDStr] ?? "";
}

export function getDefPriorPopAbbrFromMstID(mstIDStr) {
  let name = "";

  switch (mstIDStr) {
    case pisc.SDC_PP_MstID:
      name = RS(SC.GB_stSDCAbbr);
      break;

    case pisc.AGYW_PP_MstID:
      name = RS(SC.GB_stAGYWAbbr);
      break;

    case pisc.MSM_PP_MstID:
      name = RS(SC.GB_stMSMAbbr);
      break;

    case pisc.FSW_PP_MstID:
      name = RS(SC.GB_stFSWAbbr);
      break;

    case pisc.PWID_PP_MstID:
      name = RS(SC.GB_stIDUAbbr);
      break;

    case pisc.PBW_PP_MstID:
      name = RS(SC.GB_stPBWAbbr);
      break;

    case pisc.TP_PP_MstID:
      name = RS(SC.GB_stTPAbbr);
      break;

    default:
      break;
  }

  return name;
}

// export function getDefPriorPopMstID(currIDInt) {
//   let mstID = 0;

//   switch (currIDInt) {
//     case pic.SDC_PPCurrID:
//       mstID = pisc.SDC_PP_MstID;
//       break;

//     case pic.AGYW_PPCurrID:
//       mstID = pisc.AGYW_PP_MstID;
//       break;

//     case pic.MSM_PPCurrID:
//       mstID = pisc.MSM_PP_MstID;
//       break;

//     case pic.FSW_PPCurrID:
//       mstID = pisc.FSW_PP_MstID;
//       break;

//     case pic.PWIDU_PPCurrID:
//       mstID = pisc.PWID_PP_MstID;
//       break;

//     default:
//       break;
//   }

//   return mstID;
// }

export function getDefPriorPopCurrID(mstIDInt) {
  let currID = 0;

  switch (mstIDInt) {
    case pisc.SDC_PP_MstID:
      currID = pic.SDC_PPCurrID;
      break;

    case pisc.AGYW_PP_MstID:
      currID = pic.AGYW_PPCurrID;
      break;

    case pisc.MSM_PP_MstID:
      currID = pic.MSM_PPCurrID;
      break;

    case pisc.FSW_PP_MstID:
      currID = pic.FSW_PPCurrID;
      break;

    case pisc.PWID_PP_MstID:
      currID = pic.PWIDU_PPCurrID;
      break;

    default:
      break;
  }

  return currID;
}

export function getDefPriorPopImpPriorPopMstID(mstIDStr) {
  let impPriorPopMstID;

  switch (mstIDStr) {
    case pisc.SDC_PP_MstID:
      impPriorPopMstID = pisc.SDC_DIPPMstID;
      break;

    case pisc.AGYW_PP_MstID:
      impPriorPopMstID = pisc.AGYW_15_24_DIPPMstID;
      break;

    case pisc.MSM_PP_MstID:
      impPriorPopMstID = pisc.MSM_DIPPMstID;
      break;

    case pisc.FSW_PP_MstID:
      impPriorPopMstID = pisc.FSW_DIPPMstID;
      break;

    case pisc.PWID_PP_MstID:
      impPriorPopMstID = pisc.PWID_DIPPMstID;
      break;

    default:
      impPriorPopMstID = pisc.SDC_DIPPMstID;
      break;
  }

  return impPriorPopMstID;
}

export function getDefImpPriorPopNameFromMstID(mstIDStr) {
  let name = "";

  switch (mstIDStr) {
    case pisc.SDC_DIPPMstID:
      name = RS(SC.GB_stSDCAbbr);
      break;

    case pisc.FSW_DIPPMstID:
      name = RS(SC.GB_stFSWAbbr);
      break;

    case pisc.MSM_DIPPMstID:
      name = RS(SC.GB_stMSMAbbr);
      break;

    case pisc.AGYW_15_19_DIPPMstID:
      name = RS(SC.GB_stAGYW15t19);
      break;

    case pisc.AGYW_18_19_DIPPMstID:
      name = RS(SC.GB_stAGYW18t19);
      break;

    case pisc.AGYW_20_24_DIPPMstID:
      name = RS(SC.GB_stAGYW20t24);
      break;

    case pisc.AGYW_15_24_DIPPMstID:
      name = RS(SC.GB_stAGYW15t24);
      break;

    case pisc.TW_DIPPMstID:
      name = RS(SC.GB_stTW);
      break;

    case pisc.PWID_DIPPMstID:
      name = RS(SC.GB_stIDUAbbr);
      break;

    case pisc.PW_DIPPMstID:
      name = RS(SC.GB_stPW);
      break;

    case pisc.BFW_DIPPMstID:
      name = RS(SC.GB_stBFW);
      break;

    case pisc.GPW_DIPPMstID:
      name = RS(SC.GB_stGenPopWomen);
      break;

    case pisc.MRW_DIPPMstID:
      name = RS(SC.GB_stMedRiskWomen);
      break;

    case pisc.GPM_DIPPMstID:
      name = RS(SC.GB_stGenPopMen);
      break;

    case pisc.MRM_DIPPMstID:
      name = RS(SC.GB_stMedRiskMen);
      break;

    case pisc.HRM_DIPPMstID:
      name = RS(SC.GB_stHighRiskHeteroMen);
      break;

    default:
      break;
  }

  return name;
}

/* Default continuation curves */

// export function getDefContCurveCurrID(mstID) {
//   let currID;

//   switch (mstID) {
//     case pisc.SDCsCCMstID:
//       currID = pic.SDCsCCCurrID;
//       break;

//     case pisc.AGYW15t24CCMstID:
//       currID = pic.AGYW15t24CCCurrID;
//       break;

//     case pisc.MSMCCMstID:
//       currID = pic.MSMCCCurrID;
//       break;

//     case pisc.FSWCCMstID:
//       currID = pic.FSWCCCurrID;
//       break;

//     case pisc.PBWCCMstID:
//       currID = pic.PBWCCCurrID;
//       break;

//     default:
//       currID = 0;
//       break;
//   }

//   return currID;
// }

// export function getDefContCurveMstID(currID) {
//   let mstID;

//   switch (currID) {
//     case pic.SDCsCCCurrID:
//       mstID = pisc.SDCsCCMstID;
//       break;

//     case pic.AGYW15t24CCCurrID:
//       mstID = pisc.AGYW15t24CCMstID;
//       break;

//     case pic.MSMCCCurrID:
//       mstID = pisc.MSMCCMstID;
//       break;

//     case pic.FSWCCCurrID:
//       mstID = pisc.FSWCCMstID;
//       break;

//     case pic.PBWCCCurrID:
//       mstID = pisc.PBWCCMstID;
//       break;

//     default:
//       mstID = 0;
//       break;
//   }

//   return mstID;
// }

// export function getDefContCurveName(currIDInt) {
//   let name = "";

//   switch (currIDInt) {
//     case pic.SDCsCCCurrID:
//       name = RS(SC.GB_stSDCsCC);
//       break;

//     case pic.AGYW15t24CCCurrID:
//       name = RS(SC.GB_stAGYW15t24CC);
//       break;

//     case pic.MSMCCCurrID:
//       name = RS(SC.GB_stMSMAbbrCC);
//       break;

//     case pic.FSWCCCurrID:
//       name = RS(SC.GB_stFSWAbbrCC);
//       break;

//     case pic.PBWCCCurrID:
//       name = RS(SC.GB_sPBWAbbr);
//       break;

//     default:
//       break;
//   }

//   return name;
// }

export function getDefContCurveNameFromMstID(mstIDStr) {
  switch (mstIDStr) {
    case pisc.SDCsCCMstID:
      return RS(SC.GB_stSDCsCC);

    case pisc.PBWCCMstID:
      return RS(SC.GB_stPBWCC);

    case pisc.KPCCMstID:
      return RS(SC.GB_stKPsCC);

    case pisc.RingCCMstID:
      return RS(SC.GB_stRingCC);

    case pisc.LENCCMstID:
      return RS(SC.GB_stLENCC);

    case pisc.CAB_LACCMstID:
      return RS(SC.GB_stCABLA);

    default:
      return "";
  }
}

/* Methods */

export function getDefMethodNameFromMstID(mstIDStr) {
  switch (mstIDStr) {
    case pisc.pillMethodMstID:
      return RS(SC.GB_stPill);

    case pisc.ringsMethodMstID:
      return RS(SC.GB_stRing);

    case pisc.CAB_LAMethodMstID:
      return RS(SC.GB_stCABLA);

    case pisc.LENMethodMstID:
      return RS(SC.GB_stLEN);

    default:
      return "";
  }
}

export function getDefMethodUnitOfCommodityFromMstID(mstIDStr) {
  switch (mstIDStr) {
    case pisc.pillMethodMstID:
      return RS(SC.GB_stBottleLower);

    case pisc.ringsMethodMstID:
      return RS(SC.GB_stRingLower);

    case pisc.CAB_LAMethodMstID:
      return RS(SC.GB_stInjectionLower);

    case pisc.LENMethodMstID:
      return RS(SC.GB_stDose);

    default:
      return "";
  }
}

// export function getDefMethodMstID(currIDInt) {
//   let mstID = "";

//   switch (currIDInt) {
//     case pic.pillMethodCurrID:
//       mstID = pisc.pillMethodMstID;
//       break;

//     case pic.ringMethodCurrID:
//       mstID = pisc.ringsMethodMstID;
//       break;

//     case pic.CAB_LAMethodCurrID:
//       mstID = pisc.CAB_LAMethodMstID;
//       break;

//     default:
//       break;
//   }

//   return mstID;
// }

export function getDefMethodCurrID(mstIDInt) {
  let currID = 0;

  switch (mstIDInt) {
    case pisc.pillMethodMstID:
      currID = pic.pillMethodCurrID;
      break;

    case pisc.ringsMethodMstID:
      currID = pic.ringMethodCurrID;
      break;

    case pisc.CAB_LAMethodMstID:
      currID = pic.CAB_LAMethodCurrID;
      break;

    default:
      break;
  }

  return currID;
}

export function getDefMethodEnabled(mstIDStr) {
  return true;
}

/* Default scale-up trends */

export function getDefScaleUpTrendCurrID(mstID) {
  let currID;

  switch (mstID) {
    case pisc.scaleUpTrendAMstID:
      currID = pic.scaleUpTrendACurrID;
      break;

    case pisc.scaleUpTrendBMstID:
      currID = pic.scaleUpTrendBCurrID;
      break;

    case pisc.scaleUpTrendCMstID:
      currID = pic.scaleUpTrendCCurrID;
      break;

    default:
      currID = 0;
      break;
  }

  return currID;
}

// export function getDefScaleUpTrendMstID(currID) {
//   let mstID;

//   switch (currID) {
//     case pic.scaleUpTrendACurrID:
//       mstID = pisc.scaleUpTrendAMstID;
//       break;

//     case pic.scaleUpTrendBCurrID:
//       mstID = pisc.scaleUpTrendBMstID;
//       break;

//     case pic.scaleUpTrendCCurrID:
//       mstID = pisc.scaleUpTrendCMstID;
//       break;

//     default:
//       mstID = 0;
//       break;
//   }

//   return mstID;
// }

export function getDefScaleUpTrendName(currIDInt) {
  let name = "";

  switch (currIDInt) {
    case pic.scaleUpTrendACurrID:
      name = RS(SC.GB_stTrendA);
      break;

    case pic.scaleUpTrendBCurrID:
      name = RS(SC.GB_stTrendB);
      break;

    case pic.scaleUpTrendCCurrID:
      name = RS(SC.GB_stTrendC);
      break;

    default:
      break;
  }

  return name;
}

export function getDefScaleUpTrendNameFromMstID(mstIDStr) {
  let name = "";

  switch (mstIDStr) {
    case pisc.scaleUpTrendAMstID:
      name = RS(SC.GB_stTrendA);
      break;

    case pisc.scaleUpTrendBMstID:
      name = RS(SC.GB_stTrendB);
      break;

    case pisc.scaleUpTrendCMstID:
      name = RS(SC.GB_stTrendC);
      break;

    default:
      break;
  }

  return name;
}

/* Scale-up types */

export function getScaleUpTypeCurrID(mstID) {
  let currID;

  switch (mstID) {
    case pisc.sShapedScaleUpMstID:
      currID = pic.sShapedScaleUpCurrID;
      break;

    case pisc.linearScaleUpMstID:
      currID = pic.linearScaleUpCurrID;
      break;

    case pisc.constantScaleUpMstID:
      currID = pic.constantScaleUpCurrID;
      break;

    default:
      currID = 0;
      break;
  }

  return currID;
}

export function getScaleUpTypeMstID(currID) {
  let mstID;

  switch (currID) {
    case pic.sShapedScaleUpCurrID:
      mstID = pisc.sShapedScaleUpMstID;
      break;

    case pic.linearScaleUpCurrID:
      mstID = pisc.linearScaleUpMstID;
      break;

    case pic.constantScaleUpCurrID:
      mstID = pisc.constantScaleUpMstID;
      break;

    default:
      mstID = 0;
      break;
  }

  return mstID;
}

export function getScaleUpTypeName(currIDInt) {
  let name = "";

  switch (currIDInt) {
    case pic.sShapedScaleUpCurrID:
      name = RS(SC.GB_stSShaped);
      break;

    case pic.linearScaleUpCurrID:
      name = RS(SC.GB_stLinear);
      break;

    case pic.constantScaleUpCurrID:
      name = RS(SC.GB_stConstant);
      break;

    default:
      break;
  }

  return name;
}

export function getScaleUpTypeNames() {
  let scaleUpTypeNames1DStrArray = [];

  for (let sut = 1; sut <= pic.numScaleUpTypes; sut++) {
    scaleUpTypeNames1DStrArray.push(getScaleUpTypeName(sut));
  }

  return scaleUpTypeNames1DStrArray;
}

/* Data elements */

export function getDefDataElement(dataElementCurrID) {
  let defDataElementNameStr = "";

  switch (dataElementCurrID) {
    case pic.numInitPrEPCurrID:
      defDataElementNameStr = RS(SC.GB_stNumInitPrEP);
      break;

    case pic.numReinitPrEPCurrID:
      defDataElementNameStr = RS(SC.GB_stNumReinitPrEP);
      break;

    default:
      throw new Error(`Out of range index: ${dataElementCurrID}`);
  }

  return defDataElementNameStr;
}

/* Months */

export function getMonthFromMstID(monthMstID) {
  let monthCurrID;

  switch (monthMstID) {
    case pisc.JanMstID:
      monthCurrID = 1;
      break;

    case pisc.FebMstID:
      monthCurrID = 2;
      break;

    case pisc.MarMstID:
      monthCurrID = 3;
      break;

    case pisc.AprMstID:
      monthCurrID = 4;
      break;

    case pisc.MayMstID:
      monthCurrID = 5;
      break;

    case pisc.JunMstID:
      monthCurrID = 6;
      break;

    case pisc.JulMstID:
      monthCurrID = 7;
      break;

    case pisc.AugMstID:
      monthCurrID = 8;
      break;

    case pisc.SeptMstID:
      monthCurrID = 9;
      break;

    case pisc.OctMstID:
      monthCurrID = 10;
      break;

    case pisc.NovMstID:
      monthCurrID = 11;
      break;

    case pisc.DecMstID:
      monthCurrID = 12;
      break;

    default:
      monthCurrID = 0;
      break;
  }

  return monthCurrID;
}

export function getMonthMstID(currID) {
  let monthMstID;

  switch (currID) {
    case 1:
      monthMstID = pisc.JanMstID;
      break;

    case 2:
      monthMstID = pisc.FebMstID;
      break;

    case 3:
      monthMstID = pisc.MarMstID;
      break;

    case 4:
      monthMstID = pisc.AprMstID;
      break;

    case 5:
      monthMstID = pisc.MayMstID;
      break;

    case 6:
      monthMstID = pisc.JunMstID;
      break;

    case 7:
      monthMstID = pisc.JulMstID;
      break;

    case 8:
      monthMstID = pisc.AugMstID;
      break;

    case 9:
      monthMstID = pisc.SeptMstID;
      break;

    case 10:
      monthMstID = pisc.OctMstID;
      break;

    case 11:
      monthMstID = pisc.NovMstID;
      break;

    case 12:
      monthMstID = pisc.DecMstID;
      break;

    default:
      monthMstID = 0;
      break;
  }

  return monthMstID;
}

export function getMonthAbbrName(currID) {
  let name;

  switch (currID) {
    case 1:
      name = RS(SC.GB_stJanAbbr);
      break;

    case 2:
      name = RS(SC.GB_stFebAbbr);
      break;

    case 3:
      name = RS(SC.GB_stMarAbbr);
      break;

    case 4:
      name = RS(SC.GB_stAprAbbr);
      break;

    case 5:
      name = RS(SC.GB_stMayAbbr);
      break;

    case 6:
      name = RS(SC.GB_stJuneAbbr);
      break;

    case 7:
      name = RS(SC.GB_stJulyAbbr);
      break;

    case 8:
      name = RS(SC.GB_stAugAbbr);
      break;

    case 9:
      name = RS(SC.GB_stSeptAbbr);
      break;

    case 10:
      name = RS(SC.GB_stOctAbbr);
      break;

    case 11:
      name = RS(SC.GB_stNovAbbr);
      break;

    case 12:
      name = RS(SC.GB_stDecAbbr);
      break;

    default:
      name = "";
      break;
  }

  return name;
}

/**
 *
 * @param {number} startMonth
 * @param {number} startYear
 * @param {number} endMonth
 * @param {number} endYear
 * @returns
 */
export function getMonthsBetween(startMonth, startYear, endMonth, endYear) {
  let monthsBetween = 0;

  if (startYear === endYear) {
    monthsBetween = endMonth - startMonth + 1;
  } else {
    if (endYear - startYear > 1) {
      monthsBetween = (endYear - startYear - 1) * 12;
    }

    monthsBetween = monthsBetween + (12 - startMonth + 1) + endMonth;
  }

  return monthsBetween;
}

/**
 * Get number of months between two JavaScript Dates
 * @param {Date} start Start date
 * @param {Date} end End date
 * @returns {number} Number of months between start and end
 */
export function getMonthsBetweenDates(start, end) {
  let months = (end.getFullYear() - start.getFullYear()) * 12;
  months -= start.getMonth();
  months += end.getMonth();
  return months;
}

/**
 * Dates as used by much of the Avenir code. Months are 1-indexed.
 *
 * @typedef {object} AvenirDateRangeObject
 * @property {number} startYearInt
 * @property {number} endYearInt
 * @property {number} startMonthInt
 * @property {number} endMonthInt
 */

/**
 * Prop type for Avenir Date objects
 */
export const AvenirDatePropType = PropTypes.shape({
  startYearInt: PropTypes.number.isRequired,
  endYearInt: PropTypes.number.isRequired,
  startMonthInt: PropTypes.number.isRequired,
  endMonthInt: PropTypes.number.isRequired,
});

/**
 * Convert Avenir date object to JavaScript dates
 * @param {AvenirDateRangeObject} dateObj
 * @returns {{ start: Date, end: Date }} start and end date
 */
export function getDateObjectAsJSDates(dateObj) {
  return {
    start: new Date(dateObj.startYearInt, dateObj.startMonthInt - 1),
    end: new Date(dateObj.endYearInt, dateObj.endMonthInt - 1),
  };
}

/**
 * Convert JS dates to avenir date object
 * @param {{ start: Date, end: Date }} jsDates - start and end Date
 * @returns {{ startYearInt: number, endYearInt: number, startMonthInt: number, endMonthInt: number }} dateObj
 */
export function getJSDatesAsDateObject(jsDates) {
  return {
    startYearInt: jsDates.start.getFullYear(),
    startMonthInt: jsDates.start.getMonth() + 1,
    endYearInt: jsDates.end.getFullYear(),
    endMonthInt: jsDates.end.getMonth() + 1,
  };
}

/**
 * Get the current financial year
 * @returns {number} Current financial year
 */
export const getCurrentFinancialYear = () => {
  const now = new Date();

  const day = now.getDate();
  const month = now.getMonth() + 1;
  const year = now.getFullYear();

  return month <= 1 && day < 15 ? year : year + 1;
};

/**
 * Check if date range includes the year
 * @param {AvenirDateRangeObject} dateRange
 * @param {number} endFinacialYear
 * @returns {boolean}
 */
export const includesFinalYear = (dateRange, endFinacialYear) => {
  const startFinacialYear = endFinacialYear - 1;

  const startsBefore =
    dateRange.startYearInt < startFinacialYear ||
    (dateRange.startYearInt === startFinacialYear && dateRange.startMonthInt <= 10);

  const endsAfter =
    dateRange.endYearInt > endFinacialYear || (dateRange.endYearInt === endFinacialYear && dateRange.endMonthInt >= 9);

  return startsBefore && endsAfter;
};

/* Target-setting options */

export function getTargSetOption(currID) {
  let optionStr = "";

  switch (currID) {
    case pic.coverageTargSetOptCurrID:
      optionStr = RS(SC.GB_stCoverage);
      break;

    case pic.constraintsTargSetOptCurrID:
      optionStr = RS(SC.GB_stCovWithConstraints);
      break;

    case pic.manualTargSetOptCurrID:
      optionStr = RS(SC.GB_stManual);
      break;

    default:
      break;
  }

  return optionStr;
}

export function getTargSetCurrID(mstIDStr) {
  let currID = 0;

  switch (mstIDStr) {
    case pisc.coverageTargSetMstID:
      currID = pic.coverageTargSetOptCurrID;
      break;

    case pisc.constraintsTargSetMstID:
      currID = pic.constraintsTargSetOptCurrID;
      break;

    case pisc.manualTargSetMstID:
      currID = pic.manualTargSetOptCurrID;
      break;

    default:
      break;
  }

  return currID;
}

export function getTargSetMstID(currID) {
  let mstIDStr = "";

  switch (currID) {
    case pic.coverageTargSetOptCurrID:
      mstIDStr = pisc.coverageTargSetMstID;
      break;

    case pic.constraintsTargSetOptCurrID:
      mstIDStr = pisc.constraintsTargSetMstID;
      break;

    case pic.manualTargSetOptCurrID:
      mstIDStr = pisc.manualTargSetMstID;
      break;

    default:
      break;
  }

  return mstIDStr;
}

/* Costs */

export function getEduCodeStr(currID) {
  let eduCodeStr = "";

  switch (currID) {
    case pic.eduCodeICurrID:
      eduCodeStr = "I";
      break;

    case pic.eduCodeIICurrID:
      eduCodeStr = "II";
      break;

    case pic.eduCodeIIICurrID:
      eduCodeStr = "III";
      break;

    case pic.eduCodeIVCurrID:
      eduCodeStr = "IV";
      break;

    case pic.eduCodeVCurrID:
      eduCodeStr = "V";
      break;

    default:
      break;
  }

  return eduCodeStr;
}

export function getEduCodeMstID(currIDInt) {
  let mstIDStr = "";

  switch (currIDInt) {
    case pic.eduCodeICurrID:
      mstIDStr = pisc.eduCode1MstID;
      break;

    case pic.eduCodeIICurrID:
      mstIDStr = pisc.eduCode2MstID;
      break;

    case pic.eduCodeIIICurrID:
      mstIDStr = pisc.eduCode3MstID;
      break;

    case pic.eduCodeIVCurrID:
      mstIDStr = pisc.eduCode4MstID;
      break;

    case pic.eduCodeVCurrID:
      mstIDStr = pisc.eduCode5MstID;
      break;

    default:
      break;
  }

  return mstIDStr;
}

export function getEduCodeCurrID(mstIDInt) {
  let currID = 0;

  switch (mstIDInt) {
    case pisc.eduCode1MstID:
      currID = pic.eduCodeICurrID;
      break;

    case pisc.eduCode2MstID:
      currID = pic.eduCodeIICurrID;
      break;

    case pisc.eduCode3MstID:
      currID = pic.eduCodeIIICurrID;
      break;

    case pisc.eduCode4MstID:
      currID = pic.eduCodeIVCurrID;
      break;

    case pisc.eduCode5MstID:
      currID = pic.eduCodeVCurrID;
      break;

    default:
      break;
  }

  return currID;
}

export function getEduCodeArray() {
  let eduCode1DStrArray = [];

  for (let ec = 1; ec <= pic.numEduCodes; ec++) {
    eduCode1DStrArray.push(getEduCodeStr(ec));
  }

  return eduCode1DStrArray;
}

/* Impact scenario */

export function getImpScenName(currID) {
  let optionStr = "";

  switch (currID) {
    case pic.constCovImpOptCurrID:
      optionStr = RS(SC.GB_stConstCov);
      break;

    default:
      break;
  }

  return optionStr;
}

/* Continuation visit schedules */

export function getDefContVisitSchedNameFromMstID(mstIDStr) {
  let name = "";

  switch (mstIDStr) {
    case pisc.contVisitSched1MstID:
      name = RS(SC.GB_stSchedule) + " 1";
      break;

    case pisc.contVisitSched2MstID:
      name = RS(SC.GB_stSchedule) + " 2";
      break;

    case pisc.contVisitSched3MstID:
      name = RS(SC.GB_stCABLA);
      break;

    case pisc.contVisitSched4MstID:
      name = RS(SC.GB_stLEN);
      break;

    default:
      break;
  }

  return name;
}

// export function getDefContVisitSchedMstID(currIDInt) {
//   let mstID = "";

//   switch (currIDInt) {
//     case pic.contVisitSched1CurrID:
//       mstID = pisc.contVisitSched1MstID;
//       break;

//     case pic.contVisitSched2CurrID:
//       mstID = pisc.contVisitSched2MstID;
//       break;

//     case pic.contVisitSched3CurrID:
//       mstID = pisc.contVisitSched3MstID;
//       break;

//     case pic.contVisitSched4CurrID:
//       mstID = pisc.contVisitSched4MstID;
//       break;

//     default:
//       break;
//   }

//   return mstID;
// }

export function getDefContVisitSchedCurrID(mstIDInt) {
  let currID = 0;

  switch (mstIDInt) {
    case pisc.contVisitSched1MstID:
      currID = pic.contVisitSched1CurrID;
      break;

    case pisc.contVisitSched2MstID:
      currID = pic.contVisitSched2CurrID;
      break;

    case pisc.contVisitSched3MstID:
      currID = pic.contVisitSched3CurrID;
      break;

    case pisc.contVisitSched4MstID:
      currID = pic.contVisitSched4CurrID;
      break;

    default:
      break;
  }

  return currID;
}

/* Continuation visit options */

export function getContVisitOptMstID(currIDInt) {
  let mstID = "";

  switch (currIDInt) {
    case pic.yesCVOCurrID:
      mstID = pisc.yesCVOMstID;
      break;

    case pic.noCVOCurrID:
      mstID = pisc.noCVOMstID;
      break;

    case pic.dashCVOCurrID:
      mstID = pisc.dashCVOMstID;
      break;

    default:
      break;
  }

  return mstID;
}

export function getContVisitOptCurrID(mstIDStr) {
  let currIDInt = "";

  switch (mstIDStr) {
    case pisc.yesCVOMstID:
      currIDInt = pic.yesCVOCurrID;
      break;

    case pisc.noCVOMstID:
      currIDInt = pic.noCVOCurrID;
      break;

    case pisc.dashCVOMstID:
      currIDInt = pic.dashCVOCurrID;
      break;

    default:
      break;
  }

  return currIDInt;
}

export function getContVisitOption(mstIDStr) {
  let name = "";

  switch (mstIDStr) {
    case pisc.yesCVOMstID:
      name = RS(SC.GB_stYes);
      break;

    case pisc.noCVOMstID:
      name = RS(SC.GB_stNo);
      break;

    case pisc.dashCVOMstID:
      name = "-";
      break;

    default:
      break;
  }

  return name;
}

export function getContVisitOptionArray() {
  let contVisitOpt1DStrArray = [];

  for (let cvo = 1; cvo <= pic.numContVisitOptions; cvo++) {
    contVisitOpt1DStrArray.push(getContVisitOptMstID(cvo));
  }

  return contVisitOpt1DStrArray;
}

/* Age groups for Priority populations included by age/sex. */

export function getAgeGroupPPIASMstID(currIDInt) {
  let mstID = "";

  switch (currIDInt) {
    case pic.age15t19PPIASCurrID:
      mstID = pisc.age15t19PPIASMstID;
      break;

    case pic.age20t24PPIASCurrID:
      mstID = pisc.age20t24PPIASMstID;
      break;

    case pic.age25t29PPIASCurrID:
      mstID = pisc.age25t29PPIASMstID;
      break;

    case pic.age30t34PPIASCurrID:
      mstID = pisc.age30t34PPIASMstID;
      break;

    case pic.age35t39PPIASCurrID:
      mstID = pisc.age35t39PPIASMstID;
      break;

    case pic.age40t44PPIASCurrID:
      mstID = pisc.age40t44PPIASMstID;
      break;

    case pic.age45t49PPIASCurrID:
      mstID = pisc.age45t49PPIASMstID;
      break;

    case pic.age50t54PPIASCurrID:
      mstID = pisc.age50t54PPIASMstID;
      break;

    case pic.age55t59PPIASCurrID:
      mstID = pisc.age55t59PPIASMstID;
      break;

    case pic.age60t64PPIASCurrID:
      mstID = pisc.age60t64PPIASMstID;
      break;

    case pic.age65PlusPPIASCurrID:
      mstID = pisc.age65PlusPPIASMstID;
      break;

    default:
      break;
  }

  return mstID;
}

export function getAgeGroupPPIASCurrID(mstIDStr) {
  let currIDInt = "";

  switch (mstIDStr) {
    case pisc.age15t19PPIASMstID:
      currIDInt = pic.age15t19PPIASCurrID;
      break;

    case pisc.age20t24PPIASMstID:
      currIDInt = pic.age20t24PPIASCurrID;
      break;

    case pisc.age25t29PPIASMstID:
      currIDInt = pic.age25t29PPIASCurrID;
      break;

    case pisc.age30t34PPIASMstID:
      currIDInt = pic.age30t34PPIASCurrID;
      break;

    case pisc.age35t39PPIASMstID:
      currIDInt = pic.age35t39PPIASCurrID;
      break;

    case pisc.age40t44PPIASMstID:
      currIDInt = pic.age40t44PPIASCurrID;
      break;

    case pisc.age45t49PPIASMstID:
      currIDInt = pic.age45t49PPIASCurrID;
      break;

    case pisc.age50t54PPIASMstID:
      currIDInt = pic.age50t54PPIASCurrID;
      break;

    case pisc.age55t59PPIASMstID:
      currIDInt = pic.age55t59PPIASCurrID;
      break;

    case pisc.age60t64PPIASMstID:
      currIDInt = pic.age60t64PPIASCurrID;
      break;

    case pisc.age65PlusPPIASMstID:
      currIDInt = pic.age65PlusPPIASCurrID;
      break;

    default:
      break;
  }

  return currIDInt;
}

export function getAgeGroupStartPPIAS(mstIDStr) {
  let name = "";

  switch (mstIDStr) {
    case pisc.age15t19PPIASMstID:
      name = "15";
      break;

    case pisc.age20t24PPIASMstID:
      name = "20";
      break;

    case pisc.age25t29PPIASMstID:
      name = "25";
      break;

    case pisc.age30t34PPIASMstID:
      name = "30";
      break;

    case pisc.age35t39PPIASMstID:
      name = "35";
      break;

    case pisc.age40t44PPIASMstID:
      name = "40";
      break;

    case pisc.age45t49PPIASMstID:
      name = "45";
      break;

    case pisc.age50t54PPIASMstID:
      name = "50";
      break;

    case pisc.age55t59PPIASMstID:
      name = "55";
      break;

    case pisc.age60t64PPIASMstID:
      name = "60";
      break;

    case pisc.age65PlusPPIASMstID:
      name = "65+";
      break;

    default:
      break;
  }

  return name;
}

export function getAgeGroupEndPPIAS(mstIDStr) {
  let name = "";

  switch (mstIDStr) {
    case pisc.age15t19PPIASMstID:
      name = "19";
      break;

    case pisc.age20t24PPIASMstID:
      name = "24";
      break;

    case pisc.age25t29PPIASMstID:
      name = "29";
      break;

    case pisc.age30t34PPIASMstID:
      name = "34";
      break;

    case pisc.age35t39PPIASMstID:
      name = "39";
      break;

    case pisc.age40t44PPIASMstID:
      name = "44";
      break;

    case pisc.age45t49PPIASMstID:
      name = "49";
      break;

    case pisc.age50t54PPIASMstID:
      name = "54";
      break;

    case pisc.age55t59PPIASMstID:
      name = "59";
      break;

    case pisc.age60t64PPIASMstID:
      name = "64";
      break;

    case pisc.age65PlusPPIASMstID:
      name = "65+";
      break;

    default:
      break;
  }

  return name;
}

export function getAgeGroupPPIASArray() {
  let ageGroup1DStrArray = [];

  for (let a = 1; a <= pic.numAgeGroupsPPIAS; a++) {
    ageGroup1DStrArray.push(getAgeGroupPPIASMstID(a));
  }

  return ageGroup1DStrArray;
}

/* Default minute patterns */

export function getDefMinPatNameFromMstID(mstIDStr) {
  let name = "";

  switch (mstIDStr) {
    case pisc.SDCsMPMstID:
      name = RS(SC.GB_stSDCs);
      break;

    case pisc.keyPopsMPMstID:
      name = RS(SC.GB_stKeyPopCC);
      break;

    case pisc.AGYWMPMstID:
      name = RS(SC.GB_stAGYW15t24);
      break;

    case pisc.genPopMPMstID:
      name = RS(SC.GB_stGeneralPopulation);
      break;

    case pisc.dropInCenterMPMstID:
      name = RS(SC.GB_stDropInCenters);
      break;

    case pisc.pubHlthCenterMPMstID:
      name = RS(SC.GB_stPublicHealthCenters);
      break;

    case pisc.pubHospMPMstID:
      name = RS(SC.GB_stPublicHospitals);
      break;

    case pisc.privClinicMPMstID:
      name = RS(SC.GB_stPrivateClinics);
      break;

    default:
      break;
  }

  return name;
}

export function getDefMinPatArray() {
  let minPat1DStrArray = [];

  for (let mp = 1; mp <= pic.numMinPatterns; mp++) {
    const minPatMstID = getDefMinPatMstID(mp);
    minPat1DStrArray.push(getDefMinPatNameFromMstID(minPatMstID));
  }

  return minPat1DStrArray;
}

export function getDefMinPatMstID(currIDInt) {
  let mstID = 0;

  switch (currIDInt) {
    case pic.SDC_PPCurrID:
      mstID = pisc.SDCsMPMstID;
      break;

    case pic.keyPopsMPCurrID:
      mstID = pisc.keyPopsMPMstID;
      break;

    case pic.AGYWMPCurrID:
      mstID = pisc.AGYWMPMstID;
      break;

    case pic.genPopMPCurrID:
      mstID = pisc.genPopMPMstID;
      break;

    case pic.dropInCenterMPCurrID:
      mstID = pisc.dropInCenterMPMstID;
      break;

    case pic.pubHlthCenterMPCurrID:
      mstID = pisc.pubHlthCenterMPMstID;
      break;

    case pic.pubHospMPCurrID:
      mstID = pisc.pubHospMPMstID;
      break;

    case pic.privClinicMPCurrID:
      mstID = pisc.privClinicMPMstID;
      break;

    default:
      break;
  }

  return mstID;
}

export function getDefMinPatCurrID(mstIDInt) {
  let currID = 0;

  switch (mstIDInt) {
    case pisc.SDCsMPMstID:
      currID = pic.SDCsMPCurrID;
      break;

    case pisc.keyPopsMPMstID:
      currID = pic.keyPopsMPCurrID;
      break;

    case pisc.AGYWMPMstID:
      currID = pic.AGYWMPCurrID;
      break;

    case pisc.genPopMPMstID:
      currID = pic.genPopMPCurrID;
      break;

    case pisc.dropInCenterMPMstID:
      currID = pic.dropInCenterMPCurrID;
      break;

    case pisc.pubHlthCenterMPMstID:
      currID = pic.pubHlthCenterMPCurrID;
      break;

    case pisc.pubHospMPMstID:
      currID = pic.pubHospMPCurrID;
      break;

    case pisc.privClinicMPMstID:
      currID = pic.privClinicMPCurrID;
      break;

    default:
      break;
  }

  return currID;
}

export function getThreshCritMstID(currIDInt) {
  let mstID = "";

  switch (currIDInt) {
    case pic.totalCostSavingsAGYWCurrID:
      mstID = pisc.totalCostSavingsAGYWMstID;
      break;

    case pic.PrEPCostInfAvtdAGYWCurrID:
      mstID = pisc.PrEPCostInfAvtdAGYWMstID;
      break;

    default:
      break;
  }

  return mstID;
}

export function getThreshCritCurrID(mstIDStr) {
  let currID = 0;

  switch (mstIDStr) {
    case pisc.totalCostSavingsAGYWMstID:
      currID = pic.totalCostSavingsAGYWCurrID;
      break;

    case pisc.PrEPCostInfAvtdAGYWMstID:
      currID = pic.PrEPCostInfAvtdAGYWCurrID;
      break;

    default:
      break;
  }

  return currID;
}

// TODO: Review/remove
export function itemVariesByMethod(itemTypeByte) {
  // Only item that varied by method was persTypeItems but these have been removed
  return false;
}

export function getItemObjMethodMstIDField(itemTypeByte) {
  let fieldNameStr = false;

  switch (itemTypeByte) {
    case pic.contVisitSchedItems:
      fieldNameStr = pisc.contVisitSchedMethodMstID;
      break;

    default:
      break;
  }

  return fieldNameStr;
}

export function getItemObjMstIDField(itemTypeByte) {
  let fieldNameStr = false;

  switch (itemTypeByte) {
    case pic.contVisitSchedItems:
      fieldNameStr = pisc.contVisitSchedMstID;
      break;

    default:
      break;
  }

  return fieldNameStr;
}

export function usingCostsLite(costingModeMstID) {
  return costingModeMstID === pisc.costsLiteModeMstID;
}

export function getCostingModeStr(costingModeMstID) {
  let name = "";

  switch (costingModeMstID) {
    case pisc.detailedCostModeMstID:
      name = RS(SC.GB_stDetailedCosts);
      break;

    case pisc.costsLiteModeMstID:
      name = RS(SC.GB_stCostsLite);
      break;

    case pisc.noCostingModeMstID:
      name = RS(SC.GB_stNone);
      break;

    default:
      break;
  }

  return name;
}

export function getCostingModeSchedMVTag(costingModeMstID) {
  if (usingCostsLite(costingModeMstID)) return pisc.contVisitSchedLiteMVTag;

  throw new Error("Detailed costing mode no longer supported.");
}

export function resourceClick(resourceStr) {
  window.open("./resources/" + resourceStr, "_blank", "noopener,noreferrer");
}

export function URL_Click(URL_Str, openTarget = "_blank") {
  window.open(URL_Str, openTarget, "noopener,noreferrer");
}

export function serverCallSuccessful(serverResponse) {
  return typeof serverResponse[pisc.exceptionMsg] === "undefined";
}

// Params: serverReponse: Response | ModvarError | Exception
//   Response {msg: string, stringId?: string}
//   ErrorModvar: {type: "ModVarError", message: string, stringId: string, invalidSessions?: string[]}
//   Exception: {message: string, cause: ErrorModVar | {...}}
//
// Exceptions caused by a modvar error will have message/stringId extracted from cause.
// e.g PI_EasyTemplateError and PI_AggregateError
export function notifyUserOfError(serverResponse, onDialogChange) {
  const errObj = serverResponse?.cause?.type === "ModVarError" ? serverResponse.cause : serverResponse;
  const errorMsg = RS(errObj.stringId ?? "GB_stNull") || (errObj.msg ?? errObj.message);

  function renderInvalidSessionList(invalidSessions) {
    if (!Array.isArray(invalidSessions) || invalidSessions.length === 0) return null;
    return (
      <>
        <ul>
          {invalidSessions.map((name) => (
            <li>{name}</li>
          ))}
        </ul>
      </>
    );
  }

  let dialogObj = pias.getDefaultDialogObj();
  dialogObj[pias.contentStr] = (
    <div>
      <p>The following error occurred on the server: {errorMsg}</p>
      {renderInvalidSessionList(errObj?.invalidSessions)}
    </div>
  );
  dialogObj[pias.headerStr] = RS(SC.GB_stError);
  dialogObj[pias.maxWidthStr] = "sm";
  dialogObj[pias.showBool] = true;
  dialogObj[pias.styleObj] = { width: 500 };

  onDialogChange(dialogObj);
}

export function getAGYWAreaTypeMstID(currIDInt) {
  let mstIDStr = "";

  switch (currIDInt) {
    case pic.nationalArea:
      mstIDStr = pisc.AGYW_NationalAreaMstID;
      break;

    case pic.regionalArea:
      mstIDStr = pisc.AGYW_RegionalAreaMstID;
      break;

    case pic.districtArea:
      mstIDStr = pisc.AGYW_DistrictAreaMstID;
      break;

    default:
  }

  return mstIDStr;
}

export function getAGYWAreaTypeCurrID(mstIDStr) {
  let currIDInt = pic.noAreaSelected;

  switch (mstIDStr) {
    case pisc.AGYW_NationalAreaMstID:
      currIDInt = pic.nationalArea;
      break;

    case pisc.AGYW_RegionalAreaMstID:
      currIDInt = pic.regionalArea;
      break;

    case pisc.AGYW_DistrictAreaMstID:
      currIDInt = pic.districtArea;
      break;

    default:
  }

  return currIDInt;
}

export function getAGYWCostPerPYPrEPSrcMstID(currIDInt) {
  let mstIDStr = "";

  switch (currIDInt) {
    case pic.AGYW_PerPYPrEPFromCostingSrcCurrID:
      mstIDStr = pisc.AGYW_PerPYPrEPFromCostingSrcMstID;
      break;

    case pic.AGYW_EnterPerPYPrEPSrcCurrID:
      mstIDStr = pisc.AGYW_EnterPerPYPrEPSrcMstID;
      break;

    default:
  }

  return mstIDStr;
}

export function getAGYWCostPerPYPrEPSrcCurrID(mstIDStr) {
  let currIDInt = pic.noMstID;

  switch (mstIDStr) {
    case pisc.AGYW_PerPYPrEPFromCostingSrcMstID:
      currIDInt = pic.AGYW_PerPYPrEPFromCostingSrcCurrID;
      break;

    case pisc.AGYW_EnterPerPYPrEPSrcMstID:
      currIDInt = pic.AGYW_EnterPerPYPrEPSrcCurrID;
      break;

    default:
  }

  return currIDInt;
}

export function getAGYWCostPerPYARTEntryTypeMstID(currIDInt) {
  let mstIDStr = "";

  switch (currIDInt) {
    case pic.AGYW_SingleCostPerPerPYARTCurrID:
      mstIDStr = pisc.AGYW_SingleCostPerPerPYARTMstID;
      break;

    case pic.AGYW_CostPerPerPYByAreaARTCurrID:
      mstIDStr = pisc.AGYW_CostPerPerPYByAreaARTMstID;
      break;

    default:
  }

  return mstIDStr;
}

export function getAGYWCostPerPYARTEntryTypeCurrID(mstIDStr) {
  let currIDInt = pic.noMstID;

  switch (mstIDStr) {
    case pisc.AGYW_SingleCostPerPerPYARTMstID:
      currIDInt = pic.AGYW_SingleCostPerPerPYARTCurrID;
      break;

    case pisc.AGYW_CostPerPerPYByAreaARTMstID:
      currIDInt = pic.AGYW_CostPerPerPYByAreaARTCurrID;
      break;

    default:
  }

  return currIDInt;
}

/*********************************************************************
 *
 *    Warnings
 *
 ********************************************************************/

export function getWarning(warningMstIDStr) {
  let warningStr = "";

  switch (warningMstIDStr) {
    case pisc.targetStartDateWarning:
      warningStr = RS(SC.GB_stTargetStartDateWarning);
      break;

    default:
      break;
  }

  return warningStr;
}
